module.exports = __webpack_public_path__ + "static/media/05_before.54b5e443.jpg";